import axios from 'axios';
import config from '@/config/env-constants';

export default {

    getAssetIssuances(filterBy, view, currUserId) {
        const url = `${config.cloudFunctionsBaseUrl}/getAssetIssuances`;
        return axios.post(url, {
            view: view,
            currUserId: currUserId,
            filterBy: JSON.stringify(filterBy)
        });
    },

    saveAssetIssuances(param) {
        let url = `${config.cloudFunctionsBaseUrl}/saveAssetIssuances`;
        return axios.post(url, {
            currUserId: param.currUserId,
            assetIssuances: JSON.stringify(param.assetIssuances)
        });
    },

    paginateAssetsForIssuance(page, limit, startAt, direction, filters, currUserId) {
        let url = `${config.cloudFunctionsBaseUrl}/paginateAssetsForIssuance`;
        return axios.post(url, { ...filters, page, limit, startAt, direction, currUserId });
    },
}